import { Submission, Work } from "./models";
import { filterLink } from "./validators";

export const extractObject = (inData = null) => {
  return inData instanceof Object ? inData : {};
};

export const extractEntries = (inData = null) => {
  return Object.entries(extractObject(inData));
};

export const mapEntry = (entry, self) => {
  const [key, val] = entry;
  if (self instanceof Object && Object.keys(self).includes(key)) {
    self[key] = val;
  }
};

export const initClass = (inData = null, self = null) => {
  extractEntries(inData).forEach((entry) => mapEntry(entry, self));
};


export const extractProfileObject = (submission: Submission) => {
  const { displayName, slug, contacts, statements, links, sponsors, showQrCode, programme, course, school, displayOptions, submitted } = submission;
  return JSON.parse(JSON.stringify({ displayName, slug, contacts, statements, showQrCode, programme, links, sponsors, course, school, displayOptions, submitted }));
}

export const extractWorkObject = (work: Work) => {
  const links = JSON.parse(JSON.stringify(work.links.filter(filterLink)));
  return {...JSON.parse(JSON.stringify( work )), links };
}